import script from "./DictList.vue?vue&type=script&setup=true&lang=js"
export * from "./DictList.vue?vue&type=script&setup=true&lang=js"

import "./DictList.vue?vue&type=style&index=0&id=a1172e54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1172e54"]])

export default __exports__